// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2wkq7","alertIcon":"ConfirmModal_alertIcon__3_c4q"};